// route params are strings, we want to make sure to check for string null or string undefined values
const getCorrectValueIfStringNullOrStringUndefined = value =>
  value === 'null' || value === 'undefined' ? null : value;

module.exports = getCorrectValueIfStringNullOrStringUndefined;
